<template>
  <div>
    <div class="ban-p">
      <img
        v-if="result && result.headerImg"
        :src="imageUrl + result.headerImg"
      />
    </div>
    <div class="g-snva1">
      <div class="wp">
        <subnav :type="1"></subnav>
      </div>
    </div>
    <div class="row-js1">
      <div class="wp">
        <div class="m-txtb1 lang_en">
          <h3>{{ $t("company.tit") }}</h3>
          <div v-if="introText1.length">
            <p v-for="(item, index) of introText1" :key="index">
              {{ item }}
            </p>
          </div>
          <p><br /></p>
          <div v-if="introText2.length">
            <p v-for="(item, index) of introText2" :key="index">
              {{ item }}
            </p>
          </div>
          <br />
        </div>
        <ul class="ul-datalist">
          <li>
            <div class="con">
              <countTo
                v-if="result && result.introNum1"
                v-inview="{ ref: 'num1', show: showHandle }"
                ref="num1"
                :startVal="0"
                class="top"
                :endVal="result.introNum1 * 1"
              ></countTo>
              <!-- <div class="top">{{result && result.introNum1}}</div> -->
              <p>{{ result && result.introNum1Text }}</p>
            </div>
          </li>
          <li>
            <div class="con">
              <countTo
                v-if="result && result.introNum2"
                v-inview="{ ref: 'num2', show: showHandle }"
                ref="num2"
                :startVal="0"
                class="top"
                :endVal="result.introNum2 * 1"
              ></countTo>
              <p>{{ result && result.introNum2Text }}</p>
            </div>
          </li>
          <li>
            <div class="con">
              <countTo
                v-if="result && result.introNum3"
                v-inview="{ ref: 'num3', show: showHandle }"
                ref="num3"
                :startVal="0"
                class="top"
                :endVal="result.introNum3 * 1"
              ></countTo>
              <p>{{ result && result.introNum3Text }}</p>
            </div>
          </li>
          <li>
            <div class="con">
              <countTo
                v-if="result && result.introNum4"
                v-inview="{ ref: 'num4', show: showHandle }"
                ref="num4"
                :startVal="0"
                class="top"
                :endVal="result.introNum4 * 1"
              ></countTo>
              <p>{{ result && result.introNum4Text }}</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
   <!--   :style="`background-image: url(${imageUrl}${
        result && result.visionImg
      });`" -->
    <div
      class="row-js4"
      v-if="result && result.visionHidden"
    >
    <img :src="imageUrl+visionImg" alt="" class="rowbg">
      <div class="wp">
        <div class="m-txtb2">
          <h3>{{ $t("company.tit5") }}</h3>
          <div class="txt">
            <p v-html="result && result.visionText">
              <!-- {{ result && result.visionText }} -->
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="row-js2" v-if="historyShow">
      <div class="content_wrapper">
        <div class="g-titb1">
          <h3>{{ $t("company.tit1") }}</h3>
        </div>
        <div class="m-slickb1">
          <div class="swiper-container" v-if="historyYear && historyEvent">
            <div class="swiper-wrapper">
              <div
                class="swiper-slide"
                v-for="(item, index) of historyYear"
                :key="index"
              >
                <div class="item">
                  <div class="tit">{{ item }}</div>
                  <div class="line"></div>
                  <div class="desc">
                    {{ historyEvent[index] }}
                  </div>
                </div>
              </div>
            </div>
            <!-- Add Pagination -->
            <div class="swiper-pagination swiper-pagination1"></div>
          </div>
          <!-- Add Arrows -->
          <div class="swiper-button-next swiper-button-next1"></div>
          <div class="swiper-button-prev swiper-button-prev1"></div>
        </div>
      </div>
    </div>
    <div
      class="row-js3"
      v-if="result && result.scopeText1 && result.status == 1"
    >
      <div class="wp">
        <div class="g-titb1">
          <h3>{{ $t("company.tit2") }}</h3>
          <div class="p">{{ result && result.scopeText1 }}</div>
        </div>
        <ul class="ul-scopeb1 fix">
          <li>
            <a href="javascript:;" class="con">
              <div class="icon" v-if="result && result.scopeIcon1">
                <img :src="imageUrl + result.scopeIcon1" alt="" />
              </div>
              <div class="txt">
                <h3>{{ result && result.scopeTitle1 }}</h3>
                <div class="en">{{ result && result.scopeIntro1 }}</div>
              </div>
            </a>
          </li>
          <li>
            <a href="javascript:;" class="con">
              <div class="icon" v-if="result && result.scopeIcon2">
                <img :src="imageUrl + result.scopeIcon2" alt="" />
              </div>
              <div class="txt">
                <h3>{{ result && result.scopeTitle2 }}</h3>
                <div class="en">{{ result && result.scopeIntro2 }}</div>
              </div>
            </a>
          </li>
          <li>
            <a href="javascript:;" class="con">
              <div class="icon" v-if="result && result.scopeIcon3">
                <img :src="imageUrl + result.scopeIcon3" alt="" />
              </div>
              <div class="txt">
                <h3>{{ result && result.scopeTitle3 }}</h3>
                <div class="en">{{ result && result.scopeIntro3 }}</div>
              </div>
            </a>
          </li>
          <li>
            <a href="javascript:;" class="con">
              <div class="icon" v-if="result && result.scopeIcon4">
                <img :src="imageUrl + result.scopeIcon4" alt="" />
              </div>
              <div class="txt">
                <h3>{{ result && result.scopeTitle4 }}</h3>
                <div class="en">{{ result && result.scopeIntro4 }}</div>
              </div>
            </a>
          </li>
          <li>
            <a href="javascript:;" class="con">
              <div class="icon" v-if="result && result.scopeIcon5">
                <img :src="imageUrl + result.scopeIcon5" alt="" />
              </div>
              <div class="txt">
                <h3>{{ result && result.scopeTitle5 }}</h3>
                <div class="en">{{ result && result.scopeIntro5 }}</div>
              </div>
            </a>
          </li>
          <li>
            <a href="javascript:;" class="con">
              <div class="icon" v-if="result && result.scopeIcon6">
                <img :src="imageUrl + result.scopeIcon6" alt="" />
              </div>
              <div class="txt">
                <h3>{{ result && result.scopeTitle6 }}</h3>
                <div class="en">{{ result && result.scopeIntro6 }}</div>
              </div>
            </a>
          </li>
          <li>
            <a href="javascript:;" class="con">
              <div class="icon" v-if="result && result.scopeIcon7">
                <img :src="imageUrl + result.scopeIcon7" alt="" />
              </div>
              <div class="txt">
                <h3>{{ result && result.scopeTitle7 }}</h3>
                <div class="en">{{ result && result.scopeIntro7 }}</div>
              </div>
            </a>
          </li>
          <li>
            <a href="javascript:;" class="con">
              <div class="icon" v-if="result && result.scopeIcon8">
                <img :src="imageUrl + result.scopeIcon8" alt="" />
              </div>
              <div class="txt">
                <h3>{{ result && result.scopeTitle8 }}</h3>
                <div class="en">{{ result && result.scopeIntro8 }}</div>
              </div>
            </a>
          </li>
        </ul>
      </div>
    </div>
      <!-- :style="'background-image: url(' +'\''+ imageUrl + cultureImg  +'\''+');'" -->
    <div
      class="row-js4"
    >
    <img :src="imageUrl+cultureImg" alt="" class="rowbg">
      <div class="wp">
        <div class="m-txtb2">
          <h3>{{ $t("company.tit3") }}</h3>
          <div class="txt">
            <p v-html="result && result.cultureText">
              <!-- {{ result && result.cultureText }} -->
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="row-js5"  v-if="galleryShow">
      <div class="wp">
        <div class="g-titb1">
          <h3>{{ $t("company.tit4") }}</h3>
        </div>
        <ul class="ul-picsb1">
          <li v-if="galleryImg1.length">
            <a href="javascript:;" class="con" @click="popSwiper(galleryImg1)">
              <div class="pic">
                <img :src="imageUrl + galleryImg1[0]" alt="" />
              </div>
              <div class="txt">
                <div class="tit">{{ result && result.galleryText1 }}</div>
              </div>
            </a>
          </li>
          <li v-if="galleryImg2.length">
            <a href="javascript:;" class="con" @click="popSwiper(galleryImg2)">
              <div class="pic">
                <img :src="imageUrl + galleryImg2[0]" alt="" />
              </div>
              <div class="txt">
                <div class="tit">{{ result && result.galleryText2 }}</div>
              </div>
            </a>
          </li>
          <li v-if="galleryImg3.length">
            <a href="javascript:;" class="con" @click="popSwiper(galleryImg3)">
              <div class="pic">
                <img :src="imageUrl + galleryImg3[0]" alt="" />
              </div>
              <div class="txt">
                <div class="tit">{{ result && result.galleryText3 }}</div>
              </div>
            </a>
          </li>
          <li v-if="galleryImg4.length">
            <a href="javascript:;" class="con" @click="popSwiper(galleryImg4)">
              <div class="pic">
                <img :src="imageUrl + galleryImg4[0]" alt="" />
              </div>
              <div class="txt">
                <div class="tit">{{ result && result.galleryText4 }}</div>
              </div>
            </a>
          </li>
          <li v-if="galleryImg5.length">
            <a href="javascript:;" class="con" @click="popSwiper(galleryImg5)">
              <div class="pic">
                <img :src="imageUrl + galleryImg5[0]" alt="" />
              </div>
              <div class="txt">
                <div class="tit">{{ result && result.galleryText5 }}</div>
              </div>
            </a>
          </li>
          <li v-if="galleryImg6.length">
            <a href="javascript:;" class="con" @click="popSwiper(galleryImg6)">
              <div class="pic">
                <img :src="imageUrl + galleryImg6[0]" alt="" />
              </div>
              <div class="txt">
                <div class="tit">{{ result && result.galleryText6 }}</div>
              </div>
            </a>
          </li>
        </ul>
      </div>
    </div>

    <!-- 相册弹窗 -->
    <div class="m-pop" v-if="popFlag">
      <div class="pop-bg" @click="popFlag = false"></div>
      <div class="inner">
        <span class="cls" @click="popFlag = false"></span>
        <div class="photosw">
          <div class="swiper-container" v-if="poplist.length">
            <div class="swiper-wrapper">
              <div
                class="swiper-slide"
                v-for="(item, index) of poplist"
                :key="index"
              >
                <div class="item">
                  <div class="img">
                    <img :src="imageUrl + item" alt="" />
                  </div>
                </div>
              </div>
            </div>

            <!-- Add Pagination -->
            <div class="swiper-pagination swiper-pagination2"></div>
            <!-- Add Arrows -->
            <div class="swiper-button-next swiper-button-next2"></div>
            <div class="swiper-button-prev swiper-button-prev2"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- 相册弹窗end -->
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import Swiper from 'swiper';
import { Loading } from 'element-ui';
import countTo from 'vue-count-to';
import subnav from '@/components/subnav';
export default {
  components: {
    countTo,
    subnav
  },
  data () {
    return {
      loading: true,
      result: null,
      introText1: [],
      introText2: [],

      historyShow:1, //发展历程是否显示
      historyYear: [],
      historyEvent: [],
      cultureImg:'',
      visionImg:'',
      galleryShow: 1, //图库开关
      galleryImg1: [],
      galleryImg2: [],
      galleryImg3: [],
      galleryImg4: [],
      galleryImg5: [],
      galleryImg6: [],
      lang:'zh',

      // 弹窗的swiper
      popFlag: false,
      poplist: [],

      pageInfo: {
        zhId: '1436153120979111937',
        enId: '1435871157777055745'
      }
    }
  },
  /* mounted () {
    let lang = localStorage.getItem("locale") || 'zh';
    this.lang = lang;
    this.$i18n.locale = lang;
  }, */
  created () {
    Loading.service();
    let that = this;
    /* if (that.$i18n.locale === 'zh') {
      that.getProfile(that.pageInfo.zhId);
    } else if (that.$i18n.locale === 'en') {
      that.getProfile(that.pageInfo.enId);
    } */
    that.getProfile(that.pageInfo.enId);
  },
  /* watch: {
    '$i18n.locale' (newValue) {
      Loading.service();
      let that =this;
      if (that.$i18n.locale === 'zh') {
        that.lang='zh'
        that.getProfile(that.pageInfo.zhId);
      } else if (that.$i18n.locale === 'en') {
        that.getProfile(that.pageInfo.enId);
        that.lang='en'
      }
    },

  }, */
  methods: {
    // 初始化发展历程轮播
    initSwiper () {
      new Swiper('.m-slickb1 .swiper-container', {
        slidesPerView: 4,
        observer: true,
        observeParents: true,
        pagination: {
          el: '.swiper-pagination1',
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next1',
          prevEl: '.swiper-button-prev1',
        },
        // 轮播响应式，屏幕尺寸小于767，显示1个。小于960显示2个，小于1199显示3个
        breakpoints: {
          767: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
          960: {
            slidesPerView: 2,
            spaceBetween: 10,
          },
          1199: {
            slidesPerView: 3,
            spaceBetween: 10,
          },
        }
      });
    },

    // 获取公司简介信息
    getProfile (id) {
      let that = this;
      let data = {
        id: id
      };
      that.$http
        .getProfile(data)
        .then((res) => {
          if (res.code == 200) {
            let result = res.result;
            that.result = result;
            Loading.service().close();
            // 介绍文字
            that.introText1 = result.introText1 ? result.introText1.split('\n') : [];
            that.introText2 = result.introText2 ? result.introText2.split('\n') : [];
            // 发展历程
            that.historyYear = result.historyYear ? result.historyYear.split('\n') : [];
            that.historyEvent = result.historyEvent ? result.historyEvent.split('\n') : [];
            that.cultureImg = result.cultureImg;
            that.visionImg = result.visionImg;
            //发展历程是否显示
            that.historyShow = result.historyShow;
            // 图集
            that.galleryShow = result.galleryShow;
            that.galleryImg1 = result.galleryImg1 ? result.galleryImg1.split(',') : [];
            that.galleryImg2 = result.galleryImg2 ? result.galleryImg2.split(',') : [];
            that.galleryImg3 = result.galleryImg3 ? result.galleryImg3.split(',') : [];
            that.galleryImg4 = result.galleryImg4 ? result.galleryImg4.split(',') : [];
            that.galleryImg5 = result.galleryImg5 ? result.galleryImg5.split(',') : [];
            that.galleryImg6 = result.galleryImg6 ? result.galleryImg6.split(',') : [];
            that.$nextTick(function () {
              that.initSwiper();
            })

          }
        })
        .catch((err) => {
          that.$message(
            {
              message: err,
              type: 'error'
            }
          );
        });
    },

    // 弹窗图片集
    initPopSw () {
      new Swiper('.photosw .swiper-container', {
        slidesPerView: 1,
        observer: true,
        observeParents: true,
        pagination: {
          el: '.swiper-pagination2',
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next2',
          prevEl: '.swiper-button-prev2',
        },
      });
    },
    // 展示图片集弹窗
    popSwiper (name) {
      let that = this;
      that.poplist = name;
      that.popFlag = true
      that.$nextTick(function () {
        that.initPopSw();
      })
    }
  },
}
</script>

<style>
</style>